
import {
  computed,
  defineComponent,
  nextTick,
  onMounted,
  PropType,
  ref,
  toRef,
} from "vue";
import { ITabConfig } from "@/interfaces/iTabConfig";
import { DrawerComponent } from "@/assets/ts/components";
import VZTabs from "@/components/content/VZTabs.vue";
export default defineComponent({
  name: "vz-sidedrawer",
  emit: ["close"],
  components: { VZTabs },
  props: {
    value: { type: Boolean, default: false },
    direction: { type: String, default: "rtl" },
    type: { type: String, default: "" },
    title: { type: String, default: "" },
    icon: { type: String },
    tabs: { type: Object as PropType<ITabConfig[]>, required: true },
  },
  setup(props, { emit }) {
    const selectedTab = ref<string>("");
    const tabs = toRef(props, "tabs");
    const isFullScreen = ref<boolean>(false);
    const currentWidth = computed(() => {
      return isFullScreen.value
        ? "{default:'100%', 'sm': '100%', 'md': '100%', 'lg': '100%', 'xl': '100%'}"
        : "{default:'400px', 'sm': '550px', 'md': '768px', 'lg': '992px', 'xl': '1200px'}";
    });
    onMounted(() => {
      selectedTab.value = tabs.value?.[0].name ?? "";
    });
    const handleClose = () => {
      emit("close");
    };
    const handleResize = () => {
      isFullScreen.value = !isFullScreen.value;
      nextTick(() => {
        DrawerComponent?.getInstance("vz__drawer")?.update();
      });
    };
    return {
      handleClose,
      handleResize,
      selectedTab,
      currentWidth,
      isFullScreen,
    };
  },
});
